import { createContext } from 'react';

const OfflineContext = createContext({
    offline: false,
    setOffline: () => {},
});

export default OfflineContext;
